// ChoreHabit AuthScreen v3
import { useState } from "react";

var C = {
  bg:"#0F1117", surface:"#1A1D27", surfaceHi:"#1E2230", inputBg:"#13151F",
  border:"#2E3248", accent:"#F5A623", accentDim:"rgba(245,166,35,0.1)",
  blue:"#4A90D9", blueDim:"rgba(74,144,217,0.1)", teal:"#38BFA1",
  success:"#4CAF6E", successDim:"rgba(76,175,110,0.1)",
  danger:"#E05C5C", dangerDim:"rgba(224,92,92,0.1)",
  purple:"#9B72D0", text:"#E8EAF0", dim:"#9AA0C0", muted:"#6B7094",
};

var FM = { fontFamily:"'DM Mono','Courier New',monospace" };

var inp = {
  background:"#13151F", border:"1px solid #2E3248", borderRadius:8,
  padding:"13px 14px", color:"#E8EAF0", fontSize:13,
  fontFamily:"'DM Mono','Courier New',monospace",
  outline:"none", width:"100%", boxSizing:"border-box",
};

var lbl = {
  fontSize:10, color:"#6B7094", letterSpacing:"0.12em",
  textTransform:"uppercase", fontWeight:600,
  fontFamily:"'DM Mono','Courier New',monospace",
  display:"block", marginBottom:6
};

var PLANS = [
  { id:"free",    name:"Free",            price:"$0/mo",     sub:"1 user, 3 equipment, manual entry only" },
  { id:"starter", name:"One Man Band",    price:"$19.99/mo", sub:"1 user, 10 equipment, all features" },
  { id:"captain", name:"Captain & Crew",  price:"$39.99/mo", sub:"5 users, 25 equipment, all features" },
  { id:"pro",     name:"Pro",             price:"$79.99/mo", sub:"Unlimited users and equipment" },
];

function PasswordStrength(props) {
  var p = props.password || "";
  var score = 0;
  if (p.length >= 8) score++;
  if (/[A-Z]/.test(p)) score++;
  if (/[0-9]/.test(p)) score++;
  if (/[^A-Za-z0-9]/.test(p)) score++;
  var colors = ["#E05C5C","#E05C5C","#F5A623","#38BFA1","#4CAF6E"];
  var labels = ["","Weak","Weak","Good","Strong"];
  if (!p) return null;
  return (
    <div style={{ marginTop:8 }}>
      <div style={{ display:"flex", gap:4, marginBottom:4 }}>
        {[0,1,2,3].map(function(i) {
          return <div key={i} style={{ flex:1, height:3, borderRadius:2, background:i < score ? colors[score] : "#2E3248" }} />;
        })}
      </div>
      {score > 0 && <div style={{ fontSize:10, color:colors[score], fontFamily:"'DM Mono','Courier New',monospace" }}>{labels[score]}</div>}
    </div>
  );
}

function Field(props) {
  var s1 = useState(false); var focused = s1[0]; var setFocused = s1[1];
  var s2 = useState(false); var showPw = s2[0]; var setShowPw = s2[1];
  var isPw = props.type === "password";
  return (
    <div style={{ marginBottom:16 }}>
      {props.label && (
        <label style={lbl}>
          {props.label}
          {props.required && <span style={{ color:"#F5A623" }}> *</span>}
        </label>
      )}
      <div style={{ position:"relative" }}>
        <input
          style={{ ...inp, borderColor:focused ? "#F5A623" : props.error ? "#E05C5C" : "#2E3248", paddingRight:isPw ? 52 : 14 }}
          type={isPw && showPw ? "text" : props.type || "text"}
          placeholder={props.placeholder}
          value={props.value}
          onChange={props.onChange}
          onFocus={function(){ setFocused(true); }}
          onBlur={function(){ setFocused(false); }}
          autoComplete={props.autoComplete}
        />
        {isPw && (
          <button
            onClick={function(){ setShowPw(!showPw); }}
            style={{ position:"absolute", right:12, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", color:"#6B7094", cursor:"pointer", fontSize:10, fontFamily:"'DM Mono','Courier New',monospace", padding:0, letterSpacing:"0.08em" }}
          >
            {showPw ? "HIDE" : "SHOW"}
          </button>
        )}
      </div>
      {props.error && <div style={{ fontSize:11, color:"#E05C5C", marginTop:4, fontFamily:"'DM Mono','Courier New',monospace" }}>{props.error}</div>}
      {props.hint && !props.error && <div style={{ fontSize:10, color:"#6B7094", marginTop:4, fontFamily:"'DM Mono','Courier New',monospace" }}>{props.hint}</div>}
      {isPw && props.strength && <PasswordStrength password={props.value} />}
    </div>
  );
}

var AUTH_T = {
  en: {
    tagline1:"Your chores.", tagline2:"Your habit.", tagline3:"Never fall behind.",
    sub:"Maintenance tracking, crew management, and smart alerts — built for the people who keep things running.",
    startTrial:"Start Free 30-Day Trial", signIn:"Sign In",
    noCard:"No credit card required", cancel:"Cancel anytime",
    founding:"Founding member spots available — 50% off for life",
    createAccount:"Create Account", startTrial2:"Start your free trial",
    thirtyDays:"30 days free. No credit card required.",
    choosePlan:"Choose your plan",
    welcomeBack:"Welcome Back", signInTo:"Sign in to ChoreHabit", fleetWaiting:"Your fleet is waiting.",
    forgotPw:"Forgot your password?", sendReset:"Send Reset Link",
    backToSignIn:"Back to Sign In", checkInbox:"Check your inbox",
    noAccount:"Don't have an account?", alreadyHave:"Already have an account?",
  },
  es: {
    tagline1:"Tus tareas.", tagline2:"Tu hábito.", tagline3:"Nunca te quedes atrás.",
    sub:"Seguimiento de mantenimiento, gestión de equipo y alertas inteligentes — para los que mantienen todo funcionando.",
    startTrial:"Prueba Gratis 30 Días", signIn:"Iniciar Sesión",
    noCard:"Sin tarjeta de crédito", cancel:"Cancela cuando quieras",
    founding:"Plazas de miembro fundador — 50% de descuento de por vida",
    createAccount:"Crear Cuenta", startTrial2:"Comienza tu prueba gratuita",
    thirtyDays:"30 días gratis. Sin tarjeta de crédito.",
    choosePlan:"Elige tu plan",
    welcomeBack:"Bienvenido de Nuevo", signInTo:"Iniciar sesión en ChoreHabit", fleetWaiting:"Tu flota te espera.",
    forgotPw:"¿Olvidaste tu contraseña?", sendReset:"Enviar Enlace",
    backToSignIn:"Volver al Inicio de Sesión", checkInbox:"Revisa tu bandeja de entrada",
    noAccount:"¿No tienes cuenta?", alreadyHave:"¿Ya tienes una cuenta?",
  }
};

export default function AuthScreen(props) {
  var onAuth = props.onAuth || function(){};
  var onLegal = props.onLegal || function(){};
  var authError = props.authError || null;

  var s1 = useState("landing"); var screen = s1[0]; var setScreen = s1[1];
  var s2 = useState("starter"); var plan = s2[0]; var setPlan = s2[1];
  var s_pending = useState(null); var pendingSignup = s_pending[0]; var setPendingSignup = s_pending[1];
  var s_rem = useState(true); var rememberMe = s_rem[0]; var setRememberMe = s_rem[1];
  var sL = useState("en"); var lang = sL[0]; var setLang = sL[1];

  var s3 = useState(""); var company = s3[0]; var setCompany = s3[1];
  var s4 = useState(""); var fullName = s4[0]; var setFullName = s4[1];
  var s5 = useState(""); var email = s5[0]; var setEmail = s5[1];
  var s6 = useState(""); var password = s6[0]; var setPassword = s6[1];
  var s7 = useState(""); var confirm = s7[0]; var setConfirm = s7[1];
  var s8 = useState(false); var agreed = s8[0]; var setAgreed = s8[1];
  var s9 = useState({}); var errors = s9[0]; var setErrors = s9[1];

  var s10 = useState(""); var signEmail = s10[0]; var setSignEmail = s10[1];
  var s11 = useState(""); var signPw = s11[0]; var setSignPw = s11[1];
  var s12 = useState(null); var signError = s12[0]; var setSignError = s12[1];
  var s13 = useState(false); var loading = s13[0]; var setLoading = s13[1];
  var s14 = useState(false); var forgotSent = s14[0]; var setForgotSent = s14[1];
  var s15 = useState(""); var forgotEmail = s15[0]; var setForgotEmail = s15[1];

  function validate() {
    var e = {};
    if (!company.trim()) e.company = "Company name is required";
    if (!fullName.trim()) e.fullName = "Full name is required";
    if (!email.trim() || !/\S+@\S+\.\S+/.test(email)) e.email = "Valid email required";
    if (password.length < 8) e.password = "Password must be at least 8 characters";
    if (password !== confirm) e.confirm = "Passwords do not match";
    if (!agreed) e.agreed = "You must agree to the terms to continue";
    setErrors(e);
    return Object.keys(e).length === 0;
  }

  function handleCreate() {
    if (!validate()) return;
    setLoading(true);
    onAuth({
      type:"new",
      email:email,
      password:password,
      user:{ name:fullName, email:email, company:company, plan:plan, role:"admin", lang:lang }
    });
    setLoading(false);
  }

  function handleSignIn() {
    if (!signEmail.trim() || !signPw.trim()) { setSignError("Please enter your email and password"); return; }
    setLoading(true); setSignError(null);
    onAuth({ type:"returning", email:signEmail, password:signPw });
    setLoading(false);
  }

  var css = "@import url('https://fonts.googleapis.com/css2?family=DM+Mono:wght@400;500&display=swap'); *{box-sizing:border-box;margin:0;padding:0;} ::-webkit-scrollbar{width:4px;} ::-webkit-scrollbar-thumb{background:#2E3248;border-radius:2px;} button:hover{opacity:0.88;} input[type=checkbox]{accent-color:#F5A623;width:16px;height:16px;}";

  return (
    <div style={{ ...FM, background:"#0F1117", minHeight:"100vh", color:"#E8EAF0", display:"flex", flexDirection:"column", alignItems:"center" }}>
      <style>{css}</style>
      <div style={{ width:"100%", maxWidth:480, minHeight:"100vh", display:"flex", flexDirection:"column" }}>

        {/* LANDING */}
        {screen==="landing" && (
          <div style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"40px 24px" }}>
            {/* Language toggle */}
            <div style={{ position:"absolute", top:16, right:20 }}>
              <div style={{ display:"flex", background:"#1A1D27", border:"1px solid #2E3248", borderRadius:20, overflow:"hidden" }}>
                {["en","es"].map(function(l) {
                  var sel=lang===l;
                  return <button key={l} onClick={function(){ setLang(l); }} style={{ background:sel?"#F5A623":"transparent", border:"none", color:sel?"#0F1117":"#6B7094", fontSize:10, fontFamily:"'DM Mono','Courier New',monospace", fontWeight:700, padding:"5px 12px", cursor:"pointer", textTransform:"uppercase", letterSpacing:"0.06em" }}>{l==="en"?"EN":"ES"}</button>;
                })}
              </div>
            </div>
            <div style={{ marginBottom:36, textAlign:"center" }}>
              <img src="/chorehabit-app-tile.svg" alt="ChoreHabit" style={{ width:80, height:80, margin:"0 auto 20px", display:"block", borderRadius:20 }} />
              <div style={{ fontSize:11, color:"#F5A623", letterSpacing:"0.25em", textTransform:"uppercase", fontWeight:700, marginBottom:10 }}>ChoreHabit</div>
              <div style={{ fontSize:26, fontWeight:700, lineHeight:1.2, marginBottom:8 }}>{AUTH_T[lang].tagline1}<br/>{AUTH_T[lang].tagline2}</div>
              <div style={{ fontSize:12, color:"#F5A623", fontWeight:700, letterSpacing:"0.12em", marginBottom:12, textTransform:"uppercase" }}>{AUTH_T[lang].tagline3}</div>
              <div style={{ fontSize:13, color:"#9AA0C0", lineHeight:1.7, maxWidth:300, margin:"0 auto" }}>{AUTH_T[lang].sub}</div>
            </div>

            <div style={{ width:"100%", display:"flex", flexDirection:"column", gap:10, marginBottom:32 }}>
              {[
                {i:"\uD83D\uDD27", t:"Track maintenance for every piece of equipment"},
                {i:"\uD83D\uDC65", t:"Keep your whole crew accountable from the field"},
                {i:"\uD83D\uDEA8", t:"Smart alerts before things break down"},
                {i:"\uD83D\uDCCA", t:"Weekly reports and full service history"},
              ].map(function(item) {
                return (
                  <div key={item.t} style={{ display:"flex", alignItems:"center", gap:14, background:"#1A1D27", border:"1px solid #2E3248", borderRadius:12, padding:"12px 16px" }}>
                    <span style={{ fontSize:20, flexShrink:0 }}>{item.i}</span>
                    <span style={{ fontSize:12, color:"#9AA0C0", lineHeight:1.5 }}>{item.t}</span>
                  </div>
                );
              })}
            </div>

            <div style={{ width:"100%", display:"flex", flexDirection:"column", gap:12, marginBottom:20 }}>
              <button onClick={function(){ setScreen("create"); }} style={{ width:"100%", background:"#F5A623", border:"none", borderRadius:12, color:"#0F1117", fontSize:13, fontFamily:"'DM Mono','Courier New',monospace", fontWeight:700, padding:16, cursor:"pointer", textTransform:"uppercase", letterSpacing:"0.12em", boxShadow:"0 8px 24px rgba(245,166,35,0.3)" }}>
                {AUTH_T[lang].startTrial}
              </button>
              <button onClick={function(){ setScreen("signin"); }} style={{ width:"100%", background:"none", border:"1px solid #2E3248", borderRadius:12, color:"#9AA0C0", fontSize:13, fontFamily:"'DM Mono','Courier New',monospace", fontWeight:700, padding:16, cursor:"pointer", textTransform:"uppercase", letterSpacing:"0.12em" }}>
                {AUTH_T[lang].signIn}
              </button>
            </div>

            <div style={{ fontSize:11, color:"#6B7094", textAlign:"center", lineHeight:1.8 }}>
              {AUTH_T[lang].noCard} &nbsp;&middot;&nbsp; {AUTH_T[lang].cancel}<br/>
              <span style={{ color:"#F5A623" }}>{AUTH_T[lang].founding}</span>
            </div>
          </div>
        )}

        {/* CREATE ACCOUNT */}
        {screen==="create" && (
          <div style={{ flex:1, display:"flex", flexDirection:"column", padding:"24px 24px 100px" }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:24 }}>
              <button onClick={function(){ setScreen("landing"); setErrors({}); }} style={{ background:"none", border:"none", color:"#6B7094", fontSize:11, fontFamily:"'DM Mono','Courier New',monospace", cursor:"pointer", padding:0, textTransform:"uppercase", letterSpacing:"0.1em" }}>
                &lt; Back
              </button>
              <div style={{ display:"flex", background:"#1A1D27", border:"1px solid #2E3248", borderRadius:20, overflow:"hidden" }}>
                {["en","es"].map(function(l) {
                  var sel=lang===l;
                  return <button key={l} onClick={function(){ setLang(l); }} style={{ background:sel?"#F5A623":"transparent", border:"none", color:sel?"#0F1117":"#6B7094", fontSize:10, fontFamily:"'DM Mono','Courier New',monospace", fontWeight:700, padding:"5px 12px", cursor:"pointer", textTransform:"uppercase", letterSpacing:"0.06em" }}>{l==="en"?"EN":"ES"}</button>;
                })}
              </div>
            </div>
            <div style={{ marginBottom:24 }}>
              <div style={{ fontSize:11, color:"#F5A623", letterSpacing:"0.2em", textTransform:"uppercase", fontWeight:700, marginBottom:8 }}>{AUTH_T[lang].createAccount}</div>
              <div style={{ fontSize:22, fontWeight:700, marginBottom:4 }}>{AUTH_T[lang].startTrial2}</div>
              <div style={{ fontSize:12, color:"#6B7094" }}>{AUTH_T[lang].thirtyDays}</div>
            </div>

            {/* Free trial notice */}
            <div style={{ background:"rgba(76,175,110,0.06)", border:"1px solid #4CAF6E", borderRadius:10, padding:"12px 16px", marginBottom:20 }}>
              <div style={{ fontSize:12, fontWeight:700, color:"#4CAF6E", marginBottom:3 }}>30-Day Free Trial</div>
              <div style={{ fontSize:11, color:"#9AA0C0", lineHeight:1.6 }}>Start for free — no credit card required. Upgrade anytime to unlock full features.</div>
            </div>

            <Field label="Company or Operation Name" required placeholder="Green Ridge Lawn Care" value={company} onChange={function(e){ setCompany(e.target.value); }} error={errors.company} autoComplete="organization" />
            <Field label="Your Full Name" required placeholder="Michael Caufield" value={fullName} onChange={function(e){ setFullName(e.target.value); }} error={errors.fullName} autoComplete="name" />
            <Field label="Email Address" required type="email" placeholder="you@yourcompany.com" value={email} onChange={function(e){ setEmail(e.target.value); }} error={errors.email} autoComplete="email" />
            <Field label="Password" required type="password" placeholder="8+ characters" value={password} onChange={function(e){ setPassword(e.target.value); }} error={errors.password} strength={true} autoComplete="new-password" />
            <Field label="Confirm Password" required type="password" placeholder="Repeat your password" value={confirm} onChange={function(e){ setConfirm(e.target.value); }} error={errors.confirm} autoComplete="new-password" />

            {/* Terms */}
            <div style={{ marginBottom:20 }}>
              <label style={{ display:"flex", alignItems:"flex-start", gap:10, cursor:"pointer" }}>
                <input type="checkbox" checked={agreed} onChange={function(e){ setAgreed(e.target.checked); }} style={{ marginTop:2, flexShrink:0 }} />
                <span style={{ fontSize:11, color:"#9AA0C0", lineHeight:1.6 }}>
                  I agree to the <span onClick={function(e){ e.stopPropagation(); onLegal("terms"); }} style={{ color:"#F5A623", cursor:"pointer", textDecoration:"underline" }}>Terms of Service</span> and <span onClick={function(e){ e.stopPropagation(); onLegal("privacy"); }} style={{ color:"#F5A623", cursor:"pointer", textDecoration:"underline" }}>Privacy Policy</span>. My 30-day free trial begins today.
                </span>
              </label>
              {errors.agreed && <div style={{ fontSize:11, color:"#E05C5C", marginTop:6, fontFamily:"'DM Mono','Courier New',monospace" }}>{errors.agreed}</div>}
            </div>

            {/* Founding member callout */}
            <div style={{ background:"rgba(245,166,35,0.08)", border:"1px solid #F5A623", borderRadius:10, padding:"12px 16px", marginBottom:24 }}>
              <div style={{ fontSize:12, fontWeight:700, color:"#F5A623", marginBottom:3 }}>Founding Member Spots Available</div>
              <div style={{ fontSize:11, color:"#9AA0C0", lineHeight:1.6 }}>Convert to a paid plan during your trial and lock in 50% off for life. First 10 paying customers only.</div>
            </div>

            {authError==="CHECK_EMAIL" && (
              <div style={{ background:"rgba(76,175,110,0.1)", border:"1px solid #4CAF6E", borderRadius:10, padding:"12px 14px", marginBottom:12, fontSize:12, color:"#4CAF6E", fontFamily:"'DM Mono','Courier New',monospace", lineHeight:1.6 }}>
                Account created! Check your email to confirm, then sign in.
              </div>
            )}
            {authError && authError!=="CHECK_EMAIL" && (
              <div style={{ background:"rgba(224,92,92,0.1)", border:"1px solid #E05C5C", borderRadius:10, padding:"12px 14px", marginBottom:12, fontSize:12, color:"#E05C5C", fontFamily:"'DM Mono','Courier New',monospace" }}>{authError}</div>
            )}
            <button
              onClick={handleCreate}
              disabled={loading||authError==="CHECK_EMAIL"}
              style={{ width:"100%", background:(loading||authError==="CHECK_EMAIL") ? "#1E2230" : "#F5A623", border:"none", borderRadius:12, color:(loading||authError==="CHECK_EMAIL") ? "#6B7094" : "#0F1117", fontSize:13, fontFamily:"'DM Mono','Courier New',monospace", fontWeight:700, padding:16, cursor:(loading||authError==="CHECK_EMAIL") ? "not-allowed" : "pointer", textTransform:"uppercase", letterSpacing:"0.12em", boxShadow:(loading||authError==="CHECK_EMAIL") ? "none" : "0 8px 24px rgba(245,166,35,0.3)" }}
            >
              {loading ? "Creating your account..." : "Start My Free Trial"}
            </button>
            <div style={{ textAlign:"center", marginTop:12 }}>
              <button onClick={function(){
                if (!validate()) return;
                setPendingSignup({ name:fullName, email:email, company:company, password:password, lang:lang });
                setScreen("choosePlan");
              }} style={{ background:"none", border:"none", color:"#F5A623", fontSize:12, fontFamily:"'DM Mono','Courier New',monospace", fontWeight:700, cursor:"pointer", textDecoration:"underline", letterSpacing:"0.04em" }}>
                Skip trial — choose a plan now
              </button>
            </div>

            <div style={{ textAlign:"center", marginTop:20, fontSize:12, color:"#6B7094" }}>
              Already have an account?{" "}
              <span onClick={function(){ setScreen("signin"); setErrors({}); }} style={{ color:"#F5A623", cursor:"pointer", fontWeight:700 }}>Sign in</span>
            </div>
          </div>
        )}

        {/* CHOOSE PLAN (skip trial flow) */}
        {screen==="choosePlan" && (
          <div style={{ flex:1, display:"flex", flexDirection:"column", padding:"24px 24px 100px" }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:24 }}>
              <button onClick={function(){ setScreen("create"); }} style={{ background:"none", border:"none", color:"#6B7094", fontSize:11, fontFamily:"'DM Mono','Courier New',monospace", cursor:"pointer", padding:0, textTransform:"uppercase", letterSpacing:"0.1em" }}>
                &lt; Back
              </button>
            </div>
            <div style={{ fontSize:11, color:"#F5A623", letterSpacing:"0.2em", textTransform:"uppercase", fontWeight:700, marginBottom:8 }}>Choose Your Plan</div>
            <div style={{ fontSize:22, fontWeight:700, marginBottom:4 }}>Skip the trial</div>
            <div style={{ fontSize:12, color:"#6B7094", marginBottom:24 }}>Pick a plan and get started immediately.</div>
            {/* Founding member callout */}
            <div style={{ background:"rgba(245,166,35,0.08)", border:"1px solid #F5A623", borderRadius:10, padding:"12px 16px", marginBottom:20 }}>
              <div style={{ fontSize:12, fontWeight:700, color:"#F5A623", marginBottom:3 }}>⭐ Founding Member Spots Available</div>
              <div style={{ fontSize:11, color:"#9AA0C0", lineHeight:1.6 }}>First 10 paying customers lock in 50% off for life.</div>
            </div>
            {[
              {id:"starter", name:"One Man Band", price:"$19.99/mo", sub:"1 user · 10 equipment · All features"},
              {id:"captain", name:"Captain & Crew", price:"$39.99/mo", sub:"5 users · 25 equipment · Crew management"},
              {id:"pro",     name:"Pro",            price:"$79.99/mo", sub:"Unlimited users & equipment"},
            ].map(function(p) {
              var sel = plan===p.id;
              return (
                <div key={p.id} onClick={function(){ setPlan(p.id); }} style={{ background:sel?"rgba(245,166,35,0.1)":"#1A1D27", border:"1.5px solid "+(sel?"#F5A623":"#2E3248"), borderRadius:10, padding:"14px 16px", cursor:"pointer", marginBottom:10 }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                    <div>
                      <div style={{ fontSize:13, fontWeight:700, color:sel?"#F5A623":"#E8EAF0" }}>{p.name}</div>
                      <div style={{ fontSize:10, color:"#6B7094", marginTop:2 }}>{p.sub}</div>
                    </div>
                    <div style={{ fontSize:14, fontWeight:700, color:sel?"#F5A623":"#9AA0C0" }}>{p.price}</div>
                  </div>
                </div>
              );
            })}
            <button
              onClick={function(){
                if (!pendingSignup) return;
                // First create account then redirect to Stripe
                onAuth({ type:"new", email:pendingSignup.email, password:pendingSignup.password, user:{ name:pendingSignup.name, email:pendingSignup.email, company:pendingSignup.company, plan:plan, role:"admin", lang:pendingSignup.lang||"en" }, skipTrial:true, plan:plan });
              }}
              style={{ width:"100%", background:"#F5A623", border:"none", borderRadius:12, color:"#0F1117", fontSize:13, fontFamily:"'DM Mono','Courier New',monospace", fontWeight:700, padding:16, cursor:"pointer", textTransform:"uppercase", letterSpacing:"0.12em", marginTop:8, boxShadow:"0 8px 24px rgba(245,166,35,0.3)" }}
            >
              Create Account & Pay Now →
            </button>
          </div>
        )}

        {/* SIGN IN */}
        {screen==="signin" && (
          <div style={{ flex:1, display:"flex", flexDirection:"column", padding:"24px 24px 60px" }}>
            <button onClick={function(){ setScreen("landing"); setSignError(null); }} style={{ background:"none", border:"none", color:"#6B7094", fontSize:11, fontFamily:"'DM Mono','Courier New',monospace", cursor:"pointer", padding:0, marginBottom:28, textTransform:"uppercase", letterSpacing:"0.1em", alignSelf:"flex-start" }}>
              &lt; Back
            </button>

            <div style={{ marginBottom:32 }}>
              <div style={{ fontSize:11, color:"#F5A623", letterSpacing:"0.2em", textTransform:"uppercase", fontWeight:700, marginBottom:8 }}>Welcome Back</div>
              <div style={{ fontSize:22, fontWeight:700, marginBottom:4 }}>Sign in to ChoreHabit</div>
              <div style={{ fontSize:12, color:"#6B7094" }}>Your fleet is waiting.</div>
            </div>



            <Field label="Email Address" type="email" placeholder="you@yourcompany.com" value={signEmail} onChange={function(e){ setSignEmail(e.target.value); setSignError(null); }} autoComplete="email" />
            <Field label="Password" type="password" placeholder="Your password" value={signPw} onChange={function(e){ setSignPw(e.target.value); setSignError(null); }} autoComplete="current-password" />

            <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:16, cursor:"pointer" }} onClick={function(){ setRememberMe(!rememberMe); }}>
              <div style={{ width:20, height:20, borderRadius:5, border:"2px solid "+(rememberMe?"#F5A623":"#2E3248"), background:rememberMe?"#F5A623":"transparent", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                {rememberMe && <span style={{ color:"#0F1117", fontSize:12, fontWeight:900, lineHeight:1 }}>{"✓"}</span>}
              </div>
              <span style={{ fontSize:12, color:"#9AA0C0", fontFamily:"'DM Mono','Courier New',monospace" }}>Keep me signed in</span>
            </div>

            {(signError||authError) && (
              <div style={{ background:"rgba(224,92,92,0.1)", border:"1px solid #E05C5C", borderRadius:8, padding:"10px 14px", marginBottom:16, fontSize:12, color:"#E05C5C", fontFamily:"'DM Mono','Courier New',monospace" }}>
                {authError==="CHECK_EMAIL" ? (
                  <div style={{ color:"#4CAF6E" }}>Check your email to confirm your account, then sign in here.</div>
                ) : (authError||signError)}
              </div>
            )}

            <button
              onClick={handleSignIn}
              disabled={loading}
              style={{ width:"100%", background:loading ? "#1E2230" : "#F5A623", border:"none", borderRadius:12, color:loading ? "#6B7094" : "#0F1117", fontSize:13, fontFamily:"'DM Mono','Courier New',monospace", fontWeight:700, padding:16, cursor:loading ? "not-allowed" : "pointer", textTransform:"uppercase", letterSpacing:"0.12em", boxShadow:loading ? "none" : "0 8px 24px rgba(245,166,35,0.3)", marginBottom:16 }}
            >
              {loading ? "Signing in..." : "Sign In"}
            </button>

            <div style={{ textAlign:"center", marginBottom:24 }}>
              <span onClick={function(){ setScreen("forgot"); }} style={{ fontSize:12, color:"#6B7094", cursor:"pointer", textDecoration:"underline" }}>
                Forgot your password?
              </span>
            </div>

            <div style={{ textAlign:"center", fontSize:12, color:"#6B7094" }}>
              Don't have an account?{" "}
              <span onClick={function(){ setScreen("create"); setSignError(null); }} style={{ color:"#F5A623", cursor:"pointer", fontWeight:700 }}>Start free trial</span>
            </div>
          </div>
        )}

        {/* FORGOT PASSWORD */}
        {screen==="forgot" && (
          <div style={{ flex:1, display:"flex", flexDirection:"column", padding:"24px 24px 60px" }}>
            <button onClick={function(){ setScreen("signin"); setForgotSent(false); setForgotEmail(""); }} style={{ background:"none", border:"none", color:"#6B7094", fontSize:11, fontFamily:"'DM Mono','Courier New',monospace", cursor:"pointer", padding:0, marginBottom:28, textTransform:"uppercase", letterSpacing:"0.1em", alignSelf:"flex-start" }}>
              &lt; Back
            </button>

            {!forgotSent ? (
              <div>
                <div style={{ fontSize:11, color:"#F5A623", letterSpacing:"0.2em", textTransform:"uppercase", fontWeight:700, marginBottom:8 }}>Reset Password</div>
                <div style={{ fontSize:22, fontWeight:700, marginBottom:8 }}>Forgot your password?</div>
                <div style={{ fontSize:13, color:"#9AA0C0", lineHeight:1.7, marginBottom:32 }}>Enter your email and we'll send a reset link.</div>
                <Field label="Email Address" type="email" placeholder="you@yourcompany.com" value={forgotEmail} onChange={function(e){ setForgotEmail(e.target.value); }} autoComplete="email" />
                <button
                  onClick={function(){ if (forgotEmail.trim()) setForgotSent(true); }}
                  disabled={!forgotEmail.trim()}
                  style={{ width:"100%", background:forgotEmail.trim() ? "#F5A623" : "#1E2230", border:"none", borderRadius:12, color:forgotEmail.trim() ? "#0F1117" : "#6B7094", fontSize:13, fontFamily:"'DM Mono','Courier New',monospace", fontWeight:700, padding:16, cursor:forgotEmail.trim() ? "pointer" : "not-allowed", textTransform:"uppercase", letterSpacing:"0.12em" }}
                >
                  Send Reset Link
                </button>
              </div>
            ) : (
              <div style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", textAlign:"center" }}>
                <div style={{ fontSize:56, marginBottom:20 }}>{"📬"}</div>
                <div style={{ fontSize:11, color:"#4CAF6E", letterSpacing:"0.2em", textTransform:"uppercase", fontWeight:700, marginBottom:12 }}>Email Sent</div>
                <div style={{ fontSize:20, fontWeight:700, marginBottom:12 }}>Check your inbox</div>
                <div style={{ fontSize:13, color:"#9AA0C0", lineHeight:1.7, maxWidth:280, marginBottom:32 }}>
                  We sent a reset link to <span style={{ color:"#F5A623" }}>{forgotEmail}</span>. Check spam if you don't see it.
                </div>
                <button
                  onClick={function(){ setScreen("signin"); setForgotSent(false); setForgotEmail(""); }}
                  style={{ background:"#F5A623", border:"none", borderRadius:12, color:"#0F1117", fontSize:13, fontFamily:"'DM Mono','Courier New',monospace", fontWeight:700, padding:"14px 32px", cursor:"pointer", textTransform:"uppercase", letterSpacing:"0.12em" }}
                >
                  Back to Sign In
                </button>
              </div>
            )}
          </div>
        )}

      </div>
    </div>
  );
}
